import backIcon from "assets/images/back-icon.svg";
import { Link, useLocation } from "react-router-dom";
import * as Styles from "./Anlegen.styles";

import { routerNameToSave } from "helper/routeHelper";
import { useRouteNavigation } from "hooks/useRouteNavigation";
import Loader from "assets/images/health-analyse/loader.svg";
import HandWithMobile from "assets/images/health-analyse/hand-mobile.png";
import NutritionCreation from "pages/nutritionCreation/NutritionCreation";

function Anlegen({ currentPath }) {
  const location = useLocation();
  const { handleNavigate, handleNavigateBack } = useRouteNavigation();

  routerNameToSave(location.state?.params ?? "");

  const handleNextPage = () => {
    handleNavigate(currentPath);
  };

  const goBack = () => {
    handleNavigateBack(currentPath);
  };

  return (
    <Styles.Container>
      {/* <Styles.ContentSection> */}
      <NutritionCreation />
      {/* <div>
          <img src={Loader} alt="loader" />
          <Styles.Title>
            Wir machen deine App, und dein Coaching startklar.
          </Styles.Title>
        </div>
        <img
          src={HandWithMobile}
          alt="HandWithMobile"
          className="handwithmobile"
        /> */}
      {/* </Styles.ContentSection> */}
    </Styles.Container>
  );
}

export default Anlegen;
